// === TYPES ITEMS & ÉQUIPEMENT ===

/** Catégorie d'équipement */
export type ItemSlot = 'weapon' | 'armor' | 'belt' | 'ring' | 'boots' | 'backpack';

/** Slots d'équipement personnel (sans sac à dos — le sac est partagé) */
export type PersonalSlot = 'weapon' | 'armor' | 'belt' | 'ring' | 'boots';

/** Liste ordonnée des slots personnels */
export const PERSONAL_SLOTS: PersonalSlot[] = ['weapon', 'armor', 'belt', 'ring', 'boots'];

/** Rareté d'un item */
export type ItemRarity = 'common' | 'uncommon' | 'rare';

/** Définition statique d'un item (template) */
export interface ItemDefinition {
  id: string;
  name: string;
  emoji: string;
  /** ID de l'icône SVG (SpriteRenderer) */
  iconId?: string;
  slot: ItemSlot;
  rarity: ItemRarity;
  description: string;
  // Bonus de stats appliqués quand équipé
  bonuses: Partial<ItemBonuses>;
}

/** Bonus possibles d'un item */
export interface ItemBonuses {
  attack: number;
  defense: number;
  maxHp: number;
  pa: number;
  pm: number;
  range: number;     // portée de l'attaque de base
  capacity: number;  // places supplémentaires dans le sac
}

/** Instance d'un item dans l'inventaire (avec un ID unique) */
export interface ItemInstance {
  uid: string;          // ID unique de l'instance
  definitionId: string; // Réfère à ItemDefinition.id
}

/** Slots d'équipement du joueur (legacy — inclut backpack) */
export interface EquipmentSlots {
  weapon: ItemInstance | null;
  armor: ItemInstance | null;
  belt: ItemInstance | null;
  ring: ItemInstance | null;
  boots: ItemInstance | null;
  backpack: ItemInstance | null;
}

/** Équipement personnel d'un personnage (5 slots, sans sac à dos) */
export interface PersonalEquipment {
  weapon: ItemInstance | null;
  armor: ItemInstance | null;
  belt: ItemInstance | null;
  ring: ItemInstance | null;
  boots: ItemInstance | null;
}

/** Instance d'un consommable dans l'inventaire */
export interface ConsumableInstance {
  uid: string;
  definitionId: string;
}

/** Catégorie d'item */
export type ItemCategory = 'equipment' | 'consumable';

/** Définition d'un consommable */
export interface ConsumableDefinition {
  id: string;
  name: string;
  emoji: string;
  /** ID de l'icône SVG (SpriteRenderer) */
  iconId?: string;
  rarity: ItemRarity;
  description: string;
  /** Effet en combat (utilisé via le système de consommables) */
  effect: ConsumableEffect;
}

/** Effet d'un consommable */
export interface ConsumableEffect {
  heal?: number;       // soigne X HP
  damage?: number;     // inflige X dégâts (zone ou ciblé)
  aoe?: number;        // rayon zone d'effet (0 = ciblé)
  throwRange?: number; // portée de lancer (cases) — pour les consommables damage+aoe
  bonusPa?: number;    // +PA ce tour
  bonusPm?: number;    // +PM ce tour
}
